/*
 * Application State should be all within this file.
 */

// Import CSV data directly using DSV plugin
import islandsData from "@/assets/Reference Map Content - Islands.csv";
import culturalRegionsData from "@/assets/Reference Map Content - Cultural Regions.csv";
import migrationRoutesData from "@/assets/Reference Map Content - Migration Routes.csv";
import diasporasData from "@/assets/Reference Map Content - Diasporas.csv";

const app = {
  state: () => ({
    // Map data - populated directly from imported CSV files
    islands: islandsData,
    culturalRegions: culturalRegionsData,
    migrationRoutes: migrationRoutesData,
    diasporas: diasporasData,

    // UI state
    selectedItem: null,
    activeLayers: {
      cultural: false,
      migration_wave_1: false,
      migration_wave_2: false
    },
    mapSettings: {
      zoomToSelected: false, // Toggle for auto-zoom on selection
      initialBounds: null // Calculated at startup from map.json
    }
  }),
  mutations: {
    SET_SELECTED_ITEM(state, item) {
      state.selectedItem = item;
    },
    CLEAR_SELECTION(state) {
      state.selectedItem = null;
    },
    SET_ACTIVE_LAYER_EXCLUSIVE(state, layer) {
      if (layer === "none") {
        // When "none" is selected, disable all layers
        Object.keys(state.activeLayers).forEach((key) => {
          state.activeLayers[key] = false;
        });
      } else {
        // For other layers, set only the selected one to true
        // Reset all layers first
        Object.keys(state.activeLayers).forEach((key) => {
          state.activeLayers[key] = false;
        });
        // Set the selected layer to true
        if (state.activeLayers.hasOwnProperty(layer)) {
          state.activeLayers[layer] = true;
        }
      }
    },
    SET_ZOOM_TO_SELECTED(state, enabled) {
      state.mapSettings.zoomToSelected = enabled;
    },
    SET_INITIAL_BOUNDS(state, bounds) {
      state.mapSettings.initialBounds = bounds;
    }
  },
  actions: {
    selectItem({ commit }, item) {
      commit("SET_SELECTED_ITEM", item);
    },
    clearSelection({ commit }) {
      commit("CLEAR_SELECTION");
    },
    setActiveLayerExclusive({ commit }, layer) {
      commit("SET_ACTIVE_LAYER_EXCLUSIVE", layer);
    },
    toggleZoomToSelected({ commit }, enabled) {
      commit("SET_ZOOM_TO_SELECTED", enabled);
    },
    setInitialBounds({ commit }, bounds) {
      commit("SET_INITIAL_BOUNDS", bounds);
    },
    mapFromDatastore({ commit, state }, payload) {
      /*
       * This is called whenever the Datastore/entry changes.
       * This is an opportunity for you to map stored values
       * back into your state.
       */
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      // Map datastore payload back to app state if needed
      // Currently no mapping needed, but structure is here for future use
    }
  },
  getters: {
    // Data getters
    getIslands: (state) => state.islands,
    getCulturalRegions: (state) => state.culturalRegions,
    getMigrationRoutes: (state) => state.migrationRoutes,
    getDiasporas: (state) => state.diasporas,

    // UI state getters
    selectedItem: (state) => state.selectedItem,
    activeLayers: (state) => state.activeLayers,
    mapSettings: (state) => state.mapSettings,

    mapToDatastore(state) {
      /*
       * Datastore Payload is only used whenever you're using the
       * Datastore (or Datasheets). This is an object
       */
      let payload = {
        // Add any app state that should be persisted to datastore
      };

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
